import { WebhooksSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOrToken,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = WebhooksSchemaTypes.paths;

const spec = () => ({
  baseUrl: `${getEnv().webhooksServiceBase}/webhooks/v1`,
  select: aaaTokenOrToken,
});

export const useWebhooksApi = () => useAuthenticatedApi<Paths>(spec());

/** Stable client for imperative use (callbacks, queryFn). Rebuilt only when the token changes. */
export const useWebhooksFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());
